import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import LinkedText from "../linkedText/linkedText.component";

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqListProps {
  items: FaqItem[];
}

// Website 2.0 FAQ: the shadcn Accordion with the preview's ruled rows,
// running the full width of the section container.
// `multiple` so several answers can stay open, like the preview's <details>.
const FaqList = ({ items }: FaqListProps) => (
  <Accordion type="multiple" className="w-full">
    {items.map((item) => (
      <AccordionItem
        key={item.question}
        value={item.question}
        className="border-t border-line last:border-b"
      >
        <AccordionTrigger className="items-center gap-6 rounded-none py-[22px] text-[1.12rem] leading-snug font-semibold text-ink hover:no-underline">
          {item.question}
        </AccordionTrigger>
        <AccordionContent className="pr-12 pb-6 text-base leading-relaxed text-ink-muted">
          <LinkedText text={item.answer} />
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default FaqList;
